<template functional>
  <a-sub-menu :key="props.menuInfo.path">
    <span slot="title">
      <span class="anticon" v-if="props.menuInfo.meta.icon">
        <svg-icon :icon-class="props.menuInfo.meta.icon"></svg-icon>
      </span>

      <span>{{ props.menuInfo.meta.title }}</span>
    </span>
    <template v-for="item in props.menuInfo.children">
      <!-- 一级菜单 -->
      <a-menu-item v-if="!item.children" :key="item.path">
        <router-link :to="item.path">
          <span class="anticon" v-if="item.meta.icon">
            <svg-icon :icon-class="item.meta.icon"></svg-icon>
          </span>
          <span>{{ item.meta.title }}</span>
        </router-link>
      </a-menu-item>
      <!-- 多级菜单 -->
      <sub-menu v-if="item.children && item.children.length > 0" :key="item.path" :menu-info="item" />
    </template>
  </a-sub-menu>
</template>
<script>
export default { props: ['menuInfo'], name: 'SubMenu' }
</script>
<style lang="less" scoped>
/deep/ .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background: rgba(71, 186, 144, 0.07);
  a {
    color: @theme-color;
  }
}
/deep/ .ant-menu-item a:hover {
  color: @theme-color;
}
::v-deep.ant-menu-submenu-selected {
  color: @theme-color !important;
}
/deep/ .ant-menu-submenu-selected a {
  color: @theme-color !important;
}

/deep/ .ant-menu-submenu-title:hover {
  color: @theme-color !important;
}
::v-deep.ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::before {
  background: linear-gradient(to right, @theme-color, @theme-color);
}
::v-deep.ant-menu-submenu-inline > .ant-menu-submenu-title:hover .ant-menu-submenu-arrow::after {
  background: linear-gradient(to right, @theme-color, @theme-color);
}
/deep/ .ant-menu-vertical .ant-menu-item::after,
.ant-menu-vertical-left .ant-menu-item::after,
.ant-menu-vertical-right .ant-menu-item::after,
.ant-menu-inline .ant-menu-item::after {
  border-right: 3px solid @theme-color;
}

.ant-menu-item > a:hover {
  color: @theme-color !important;
}
.ant-menu-item-selected > a,
.ant-menu-item-selected > a:hover {
  color: @theme-color !important;
}
.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background: @item-selected;
}

.ant-menu-item:hover,
.ant-menu-item-active,
.ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
.ant-menu-submenu-active,
.ant-menu-submenu-title:hover {
  color: @theme-color !important;
}
</style>
